import { Object, String, Static, Intersect, Optional } from '@sinclair/typebox';

import { StringEnumSchema } from '../../../utils';
import { PointOfSale } from '../../sas-domain/pos';
import { RequestHeaders } from '../headers';

export const TravelPassRequestHeaders = Intersect([
  RequestHeaders,
  Object({
    authorization: Optional(String()),
    pos: Optional(StringEnumSchema(PointOfSale)),
  }),
]);

// Headers for endpoints that require POS (/flights, /confirm)--not in use as of now since app does not support it
export const TravelPassRequestHeadersWithRequiredPOS = Intersect([
  RequestHeaders,
  Object({
    authorization: Optional(String()),
    pos: StringEnumSchema(PointOfSale), // Required POS
  }),
]);

export type TravelPassRequestHeaders = Static<typeof TravelPassRequestHeaders>;
export type TravelPassRequestHeadersWithRequiredPOS = Static<typeof TravelPassRequestHeadersWithRequiredPOS>;
